import { getAuth } from 'firebase/auth';
import { apiClient } from './api.js';

export const authService = {
  getIdToken: async () => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      throw new Error('No user authenticated');
    }
    return user.getIdToken();
  },

  register: async (fullName) => {
    const token = await authService.getIdToken();
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const response = await apiClient.post('/api/auth/register', { fullName }, config);
    return response.data;
  },

  login: async () => {
    const token = await authService.getIdToken();
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const response = await apiClient.post('/api/auth/login', {}, config);
    if (response.data?.user) {
      localStorage.setItem('qbkart_user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  getMe: async () => {
    const token = await authService.getIdToken();
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const response = await apiClient.get('/api/auth/me', config);
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('qbkart_user');
  },
};
